export const COUNTRIES = [
	{ code: 'US', name: 'United States' },
	{ code: 'CA', name: 'Canada' },
	{ code: 'GB', name: 'United Kingdom' },
	{ code: 'AU', name: 'Australia' },
	{ code: 'NZ', name: 'New Zealand' },
	{ code: 'BR', name: 'Brazil' },
	{ code: 'MX', name: 'Mexico' },
	{ code: 'AR', name: 'Argentina' },
	{ code: 'CL', name: 'Chile' },
	{ code: 'CO', name: 'Colombia' },
	{ code: 'PE', name: 'Peru' },
	{ code: 'DE', name: 'Germany' },
	{ code: 'FR', name: 'France' },
	{ code: 'IT', name: 'Italy' },
	{ code: 'ES', name: 'Spain' },
	{ code: 'PT', name: 'Portugal' },
	{ code: 'NL', name: 'Netherlands' },
	{ code: 'BE', name: 'Belgium' },
	{ code: 'CH', name: 'Switzerland' },
	{ code: 'AT', name: 'Austria' },
	{ code: 'SE', name: 'Sweden' },
	{ code: 'NO', name: 'Norway' },
	{ code: 'DK', name: 'Denmark' },
	{ code: 'FI', name: 'Finland' },
	{ code: 'PL', name: 'Poland' },
	{ code: 'CZ', name: 'Czech Republic' },
	{ code: 'IE', name: 'Ireland' },
	{ code: 'JP', name: 'Japan' },
	{ code: 'KR', name: 'South Korea' },
	{ code: 'CN', name: 'China' },
	{ code: 'IN', name: 'India' },
	{ code: 'ZA', name: 'South Africa' },
	{ code: 'RU', name: 'Russia' },
	{ code: 'TR', name: 'Turkey' },
	{ code: 'GR', name: 'Greece' },
	{ code: 'IS', name: 'Iceland' },
	{ code: 'LU', name: 'Luxembourg' },
	{ code: 'MT', name: 'Malta' },
	{ code: 'CY', name: 'Cyprus' },
	{ code: 'EE', name: 'Estonia' },
	{ code: 'LV', name: 'Latvia' },
	{ code: 'LT', name: 'Lithuania' },
	{ code: 'SK', name: 'Slovakia' },
	{ code: 'SI', name: 'Slovenia' },
	{ code: 'HU', name: 'Hungary' },
	{ code: 'RO', name: 'Romania' },
	{ code: 'BG', name: 'Bulgaria' },
	{ code: 'HR', name: 'Croatia' },
	{ code: 'RS', name: 'Serbia' },
	{ code: 'UA', name: 'Ukraine' },
	{ code: 'BY', name: 'Belarus' },
	{ code: 'UY', name: 'Uruguay' },
	{ code: 'PY', name: 'Paraguay' },
	{ code: 'BO', name: 'Bolivia' },
	{ code: 'EC', name: 'Ecuador' },
	{ code: 'VE', name: 'Venezuela' },
	{ code: 'CR', name: 'Costa Rica' },
	{ code: 'PA', name: 'Panama' },
	{ code: 'GT', name: 'Guatemala' },
	{ code: 'HN', name: 'Honduras' },
	{ code: 'NI', name: 'Nicaragua' },
	{ code: 'SV', name: 'El Salvador' },
	{ code: 'DO', name: 'Dominican Republic' },
	{ code: 'CU', name: 'Cuba' },
	{ code: 'JM', name: 'Jamaica' },
	{ code: 'TT', name: 'Trinidad and Tobago' },
	{ code: 'TH', name: 'Thailand' },
	{ code: 'VN', name: 'Vietnam' },
	{ code: 'PH', name: 'Philippines' },
	{ code: 'MY', name: 'Malaysia' },
	{ code: 'SG', name: 'Singapore' },
	{ code: 'ID', name: 'Indonesia' },
	{ code: 'TW', name: 'Taiwan' },
	{ code: 'HK', name: 'Hong Kong' },
	{ code: 'AE', name: 'United Arab Emirates' },
	{ code: 'SA', name: 'Saudi Arabia' },
	{ code: 'IL', name: 'Israel' },
	{ code: 'EG', name: 'Egypt' },
	{ code: 'MA', name: 'Morocco' },
	{ code: 'TN', name: 'Tunisia' },
	{ code: 'DZ', name: 'Algeria' },
	{ code: 'KE', name: 'Kenya' },
	{ code: 'NG', name: 'Nigeria' },
	{ code: 'GH', name: 'Ghana' },
	{ code: 'TZ', name: 'Tanzania' },
	{ code: 'ET', name: 'Ethiopia' },
	{ code: 'UG', name: 'Uganda' },
	{ code: 'ZW', name: 'Zimbabwe' },
	{ code: 'BW', name: 'Botswana' },
	{ code: 'NA', name: 'Namibia' },
	{ code: 'MU', name: 'Mauritius' },
	{ code: 'RE', name: 'Réunion' },
	{ code: 'NZ', name: 'New Zealand' },
	{ code: 'FJ', name: 'Fiji' },
	{ code: 'PG', name: 'Papua New Guinea' },
	{ code: 'NC', name: 'New Caledonia' },
	{ code: 'PF', name: 'French Polynesia' },
	{ code: 'OTHER', name: 'Other' }
].sort((a, b) => a.name.localeCompare(b.name));

export const getCountryName = (code: string): string => {
	const country = COUNTRIES.find(c => c.code === code);
	return country ? country.name : code;
};
